import React from 'react';
import { AlertCircle, XCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-200">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-201">
        <div className="text-center mb-16" data-id="element-202">
          <h2 className="text-3xl md:text-4xl font-bold text-[#44403C] mb-6" data-id="element-203">
            La verdad incómoda
          </h2>
          <p className="text-lg md:text-xl text-[#57534E] leading-relaxed" data-id="element-204">
            Porque cuando tu hijo estornuda, se rasca, o amanece con la nariz
            tapada… tú haces lo que haría cualquiera: limpias más. Cambias un
            producto. Compras otro que dice “natural”.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16" data-id="element-205">
          <div className="bg-[#F5F1EB] p-8 rounded-2xl" data-id="element-206">
            <h3 className="text-xl font-bold text-[#44403C] mb-4 flex items-center gap-2" data-id="element-207">
              <AlertCircle className="text-[#C97D60]" data-id="element-208" />
              El ciclo del agotamiento
            </h3>
            <ul className="space-y-4" data-id="element-209">
              {['Cambias un spray por otro y nada mejora', "Compras productos 'eco' pensando que ya está", 'Te llenas de botellas… y de dudas', 'Sientes culpa silenciosa cuando el niño empeora'].map((item, i) => <li key={i} className="flex items-start gap-3 text-[#57534E]" data-id="element-210">
                  <XCircle className="w-5 h-5 text-[#C97D60] flex-shrink-0 mt-0.5" data-id="element-211" />
                  <span data-id="element-212">{item}</span>
                </li>)}
            </ul>
          </div>

          <div data-id="element-213">
            <p className="text-lg text-[#57534E] mb-6" data-id="element-214">
              Y aun así, algunos días, parece que empeora.
            </p>
            <p className="text-lg font-medium text-[#44403C] mb-6" data-id="element-215">
              Puedes estar “limpiando” y al mismo tiempo estar metiendo más
              disparadores en casa.
            </p>
            <p className="text-[#57534E]" data-id="element-216">
              A veces por fragancias. A veces por el laundry. A veces por
              mezclar productos “suaves” que igual irritan.
            </p>
            <div className="mt-8 p-4 border-l-4 border-[#8B9D83] bg-[#FAF8F5]" data-id="element-217">
              <p className="italic text-[#57534E]" data-id="element-218">
                "El problema no es que no tengas recetas. El problema es que
                nadie te dio un <strong data-id="element-219">orden</strong>."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}